import type {TreeRoleViewResponse} from "@/api/system/log";
import {concatHttp, hasHttpQuery, isHttp, parseHttp} from "@/common/utils/common";
import qs from 'qs'
import {type FileResponse} from "@/api/global/file";
import {userDefaultAvatar} from "@/common/constants/constants";
import * as Pinia from "pinia";
import {Customer} from "@/api/customer/customer";


export type UserState = {
    userIsCached: boolean,
    user: User
    token: Token
    menuList: Menu[],
    menuListIsCached: boolean
}

export type User = {
    // 客户 ID
    id: string
    // 姓名
    name: string
    // 手机号码
    mobilePhone: string
    // 电子邮箱
    email: string
    // 昵称
    nickname: string
    // 头像文件 URL
    avatarFile: FileResponse
}

export type Token = {
    accessToken: string
    refreshToken: string
    expiresIn: number
}

export type Menu = {
    title: string
    label?: string
    icon?: Function
    key: string
    path?: string
    type?: number
    isCategory?: number
    children?: Menu[]
    closable?: boolean
    componentPath?: string
    isOpenNewWindow?: boolean
}

// export function routeRecordRawGetOpenKeys(route: RouteRecordRaw, parent?: RouteRecordRaw): RouteRecordRaw {
//     const children: RouteRecordRaw[] = []
//     if (route.children && route.children.length > 0) {
//         const openKeys: string[] = []
//         if (parent) {
//             if (parent.meta) {
//                 if (parent.meta.openKeys) {
//                     openKeys.push(...(parent.meta.openKeys as string[]))
//                 }
//             }
//         }
//         openKeys.push(route.name as string)
//         route.meta = { ...route.meta, openKeys: openKeys }
//         // console.log(route.meta)
//         route.children.forEach(child => children.push(routeRecordRawGetOpenKeys(child, route)))
//     }
//     const openKeys: string[] = []
//     if (parent) {
//         if (parent.meta) {
//             if (parent.meta.openKeys) {
//                 openKeys.push(...(parent.meta.openKeys as string[]))
//             }
//         }
//     }
//     if (route.meta) {
//         route.meta.openKeys = openKeys
//     }
//     return route
// }

export function viewToMenu(view: TreeRoleViewResponse): Menu {
    const children: Menu[] = []
    if (view.children && view.children.length > 0) {
        view.children.forEach(child => (child.type === 1 ? children.push(viewToMenu(child)) : null))
    }
    let componentPath = view.path
    let componentQuery = ''
    let componentQueryQs = {}
    const hasQuery = hasHttpQuery(componentPath)
    if (hasQuery) {
        const arr = parseHttp(componentPath)
        if (arr.length == 2) {
            componentPath = arr[0]
            componentQuery = arr[1]
            componentQueryQs = qs.parse(componentQuery)
        }
    }
    const pathIsHttp = isHttp(view.path);
    const routeName = hasQuery
        ? concatHttp(componentPath, qs.stringify(componentQueryQs))
        : view.path
    const routePath = hasQuery
        ? concatHttp(componentPath, qs.stringify(componentQueryQs))
        : view.path
    const menu: Menu = {
        title: view.name,
        label: view.name,
        key: pathIsHttp ? routeName : '/pages/pages' + routeName,
        path: pathIsHttp ? routePath : '/pages/pages' + routePath,
        type: view.type,
        isCategory: view.isCategory,
        componentPath: pathIsHttp ? routePath : '/pages/pages' + routePath,
        isOpenNewWindow: pathIsHttp
    }
    if (view.icon) {
        // const icon = Icons[view.icon]
        // if (icon) {
        //     menu.icon = () => h(icon)
        // }
    }
    view.isCategory ? (menu.children = children) : null
    return menu
}

export const useUserStore = Pinia.defineStore('user', {
    state: (): UserState => {
        return {
            userIsCached: false,
            user: {
                id: userDefaultAvatar,
                mobilePhone: '',
                email: '',
                name:'',
                nickname: '',
                avatarFile: {
                    id: '',
                    downloadUrl: ''
                },
            },
            token: {
                accessToken: '',
                refreshToken: '',
                expiresIn: 0,
            },
            menuList: [],
            menuListIsCached: false
        }
    },
    actions: {
        async getCurrent() {
            const current = await Customer.getCurrent()
            const currentUser = current?.data
            this.user = {
                id: currentUser?.id,
                mobilePhone: currentUser?.mobilePhone,
                email: currentUser?.email,
                name: currentUser?.name,
                nickname: currentUser?.nickname,
                avatarFile: currentUser?.avatarFile,
            }
            this.userIsCached = true
            // this.setRouteList()
            this.setMenuList()
            return this.user
        },
        setMenuList() {
            // const treeRoleViewList = this.user.treeRoleViewList
            const tempMenus: Menu[] = []
            // if (treeRoleViewList && treeRoleViewList.length > 0) {
            //     treeRoleViewList.forEach(view => (view.type === 1 ? tempMenus.push(viewToMenu(view)) : null))
            // }
            this.menuList = tempMenus
            this.menuListIsCached = true
        },
        // setRouteList() {
        //     // 路由
        //     const treeRoleViewList = this.user.treeRoleViewList
        //     let allLayoutChildrenRoutes = [...staticLayoutRoutes]
        //     if (treeRoleViewList && treeRoleViewList.length > 0) {
        //         const dynamicLayoutRoutes: RouteRecordRaw[] = []
        //         treeRoleViewList
        //             .filter(item => item.type === 1)
        //             .forEach(view => dynamicLayoutRoutes.push(viewToRouteRecordRaw(view)))
        //
        //         dynamicLayoutRoutes.map(route => routeRecordRawGetOpenKeys(route, undefined))
        //
        //         allLayoutChildrenRoutes = [...staticLayoutRoutes, ...dynamicLayoutRoutes]
        //     }
        //     layoutRoute.children = [...allLayoutChildrenRoutes]
        //     router.addRoute(layoutRoute)
        // },
        reset() {
            this.$reset()
        },
    },
    unistorage: true // 开启后对 state 的数据读写都将持久化
})
